import { Icon } from '@repo/foundations';
import { ACTIVITY_TYPE_TO_ICON, getEntityIconByType } from './constants';

interface ResourceLogItemIconProps {
	activityType: string;
	secodaEntityType?: string | null;
}

export function ResourceLogItemIcon({
	activityType,
	secodaEntityType,
}: ResourceLogItemIconProps) {
	if (secodaEntityType && activityType === 'CREATE_ENTITY') {
		return <Icon name={getEntityIconByType(secodaEntityType)} />;
	}

	if (!(activityType in ACTIVITY_TYPE_TO_ICON)) {
		return <Icon name="pencil" />;
	}

	return <Icon name={ACTIVITY_TYPE_TO_ICON[activityType]} />;
}
